import React from "react";
import { SmartIdWizardInfoPage } from "./SmartIdWizardInfoPage";
import { SmartIdPersonalCodeStep } from "../Adding/SmartIdPersonalCodeStep";
import { SmartIdVerificationStep } from "./SmartIdVerificationStep";
import { SmartIdRemoveBooleanQuestionStep } from "../Removing/SmartIdRemoveBooleanQuestionStep";
import CreatePasswordForSmartId from "../Removing/CreatePasswordForSmartId";

// Shared Success Step Component
export function StepSuccess({ onNavigateToProfile, messageKey = 'smart_id_add_wizard_info_page_message' }) {
  const handleNavigation = () => {
    if (onNavigateToProfile) {
      onNavigateToProfile();
    }
  };

  return (
    <SmartIdWizardInfoPage
      message={messageKey}
      buttonText='card_replacement_from_profile_page_return_btn'
      buttonOnClick={handleNavigation}
    />
  );
}

// Add Wizard Steps
export function StepPersonalCode({ onPersonalCodeSubmit, legalEntityId, personalCodeEntryError, onPersonalCodeUpdated }) {
  return (
    <div className="row row-center">
      <div className="column-desktop-4 column-tablet-12 column-mobile-12">
        <SmartIdPersonalCodeStep 
          onPersonalCodeSubmit={onPersonalCodeSubmit}
          onPersonalCodeUpdated={onPersonalCodeUpdated}
          legalEntityId={legalEntityId}
          errorMessage={personalCodeEntryError}
          topTextKey="personal_code_entry_page_info"
        />
      </div>
    </div>
  );
}

export function StepVerification({ pin, isWaiting }) {
  return (
    <div className="smart-id-prompt-container page-container">
      <SmartIdVerificationStep
        pin={pin}
        isWaiting={isWaiting}
        titleTextKey="smart_id_verification_prompt_view_title"
      />
    </div>
  );
}

// Remove Wizard Steps
export function StepBooleanQuestion({ onYesClicked }) {
  return (
    <SmartIdRemoveBooleanQuestionStep onYesClicked={onYesClicked} />
  );
}

export function StepPasswordCreation({ onPasswordSuccess }) {
  return <CreatePasswordForSmartId onSuccess={onPasswordSuccess} />;
}